<script setup>
import { computed } from 'vue';
import { UNFILED_FOLDER } from 'dashboard/composables/useTemplateFolders';

const props = defineProps({
  folders: {
    type: Array,
    default: () => [],
  },
  currentFolderId: {
    type: [Number, String],
    default: null,
  },
  unfiledLabel: {
    type: String,
    default: '',
  },
  moveLabel: {
    type: String,
    default: '',
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: '',
  },
  retryLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['assign', 'retry']);

const selectedValue = computed(() =>
  props.currentFolderId == null ? UNFILED_FOLDER : String(props.currentFolderId)
);

const onChange = event => {
  if (props.isSaving) return;
  const { value } = event.target;
  const folderId = value === UNFILED_FOLDER ? null : Number(value);
  if (folderId === props.currentFolderId) return;
  emit('assign', folderId);
};
</script>

<template>
  <div
    class="flex flex-col items-stretch gap-1 shrink-0 px-3 pb-2 md:px-0 md:pb-0 md:pt-3"
  >
    <select
      :aria-label="moveLabel"
      :value="selectedValue"
      :disabled="isSaving"
      data-testid="template-move-select"
      class="reset-base max-w-[7.5rem] min-h-10 px-2 text-xs rounded-xl bg-n-alpha-2 text-n-slate-12 outline outline-1 outline-n-weak focus:outline-n-brand disabled:opacity-50 disabled:cursor-not-allowed"
      @click.stop
      @mousedown.stop
      @change.stop="onChange"
    >
      <option :value="UNFILED_FOLDER">{{ unfiledLabel }}</option>
      <option
        v-for="folder in folders"
        :key="folder.id"
        :value="String(folder.id)"
      >
        {{ folder.name }}
      </option>
    </select>
    <p v-if="error" class="max-w-[7.5rem] text-[11px] leading-4 text-n-ruby-9">
      {{ error }}
    </p>
    <button
      v-if="error"
      type="button"
      data-testid="template-move-retry"
      :disabled="isSaving"
      class="inline-flex items-center justify-center min-h-10 px-2 text-[11px] font-medium rounded-full bg-n-alpha-2 text-n-slate-12 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-n-brand"
      @click.stop="emit('retry')"
    >
      {{ retryLabel }}
    </button>
  </div>
</template>
